<template>
    <div class="group-item" :class="{ [`group-item__color-${value.color}`]: !!value.color }">
        <p class="group-item__title">
            {{ value.agent_id }} {{ value.name }}

            <svg aria-hidden="true" width="16" height="16" v-if="value.has_incoming">
                <use href="#icon-phone-incoming-call"></use>
            </svg>
        </p>
        <p class="group-item__status" v-if="value.status">
            <span>{{ value.status.split(/(?=\()/)[0] }}</span>
            {{ value.status.split(/(?=\()/)[1] }}

            
        </p>
    </div>
</template>

<script>
    import {eventBus} from '@eventBus'
    export default {
        props: {
            value: {
                type: Object,
                required: true
            }
        },
        mounted() {
            eventBus.$on('action_update_status_user', this.updateStatus);
        },
        methods: {
            updateStatus(data) {
                if(data.user_id == this.value.id) {
                    this.value.status = data.status
                    this.value.color = data.color
                    this.value.has_incoming = data.has_incoming
                }
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>